import { Button, IconButton, Stack, Typography } from "@mui/material";
import React from "react";
import { useNavigateToTop } from "../../libs/useNavigateToTop";
import AppBarMenu from "./Menu";
import AppBarRoot from "./Root";
import { AccountBox, ArrowBack, QuestionAnswer } from "@mui/icons-material";

function AppBarReviewSystem({ title = "Local Bonsai" }) {
  const navigate = useNavigateToTop();

  return (
    <AppBarRoot
      startAction={
        <Stack direction={"row"} spacing={2}>
          {/* <AppBarMenu /> */}
          {/* Back button */}
          <IconButton onClick={() => navigate(-1)}
          color="secondary">
            <ArrowBack/>
          </IconButton>
          {/* <Typography
            onClick={() => navigate("/")}
            variant="h5"
            style={{ alignSelf: "center", color: "white" }}
          >
            {title}
          </Typography> */}
          
          <IconButton onClick={() => navigate("/account")}
          color="secondary">
            <AccountBox/>
          </IconButton>
        </Stack>
      }
      endAction={
        <Stack direction={"row"} spacing={1}>
          {/* account */}
          <IconButton onClick={()=> {navigate("/feedback")}}
          color="secondary"
          >
            <QuestionAnswer/>
          </IconButton>
          <Button variant="contained" color="secondary"
          
          onClick={() => navigate("/bonsai-guide/create")}
          >
          {/* onClick={handleCreatePlant} */}
            Create Guide
          </Button>

        </Stack>
      }
    />
  );
}

export default AppBarReviewSystem;
